export const calculateGreatCircleDistance = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
) => {
  const toRadians = (degree: any) => degree * (Math.PI / 180) // Converts degrees to radians

  lat1 = toRadians(lat1)
  lon1 = toRadians(lon1)
  lat2 = toRadians(lat2)
  lon2 = toRadians(lon2)

  if (lat1 === lat2 && lon1 === lon2) {
    return 0
  }

  const d =
    Math.acos(
      Math.sin(lat1) * Math.sin(lat2) + Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1)
    ) * 6371 // Earth's radius in kilometers
  return d
}

export const haversineFormula = (arrayofCoordintes: any[]) => {
  try {
    let distance = 0
    for (let i = 1; i < arrayofCoordintes.length; i++) {
      const c1 = arrayofCoordintes[i]
      const c0 = arrayofCoordintes[i - 1]
      distance =
        distance +
        calculateGreatCircleDistance(c1.latitude, c1.longitude, c0.latitude, c0.longitude)
    }
    return Math.round(distance * 100) / 100
  } catch (e) {
    return -1
  }
}
